import { Box, Container, Hidden, Link, List, ListItem, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import { Offers } from 'TaxAnalyticsComponents/mock';
import { DeloitteLogoButton } from '../Deloitte';
import { Fragment } from 'react';

function Copyright() {
    return (
        <Fragment>
            <Typography variant="body2" color="textSecondary" align="center">
                {'© '}
                {new Date().getFullYear()}
                {' '}
                <Link color="secondary" href="https://www.avocats.deloitte.fr/" target="_blank">
                    Deloitte Société d’Avocats
                </Link>{'. Une entité du réseau Deloitte. '}
                <Link color="secondary" href="https://www.avocats.deloitte.fr/mentions-legales/" target="_blank">
                    Mentions Légales.
                </Link>
                <Link color="secondary" href={`${process.env.REACT_APP_AZURE_ROOT_URI}/cookies`} target="_blank">
                    {' Politique des Cookies.'}
                </Link>
            </Typography>
            <Typography variant="body2" color="textSecondary" align="center">
                {'Ce site est protégé par reCAPTCHA, la '}
                <Link color="secondary" href="https://policies.google.com/privacy" target="_blank">Politique de Confidentialité</Link> {' de Google et les '}
                <Link color="secondary" href="https://policies.google.com/terms" target="_blank">Conditions d'utilisation</Link> {' s\'appliquent'}.
            </Typography>
        </Fragment>
    );
}

const footers = [
    {
        cols: 2,
        title: 'A propos',
        links: [
            { title: 'Présentation de Deloitte Société d\'Avocats', tile: { href: "https://www.avocats.deloitte.fr/" } },
            { title: 'Notre méthodologie', tile: { href: '/methodo' } }
        ]
    },
    {
        cols: 7,
        title: 'Nos offres',
        links: Offers,
    }
];



const useStyles = makeStyles((theme) => ({
    footer: {
        background: theme.palette.primary.dark,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },
    splitLine: {
        borderTop: `2px solid ${theme.palette.text.secondary}`,
    },
    space: { paddingTop: '32px', paddingLeft: '80px', paddingRight: '80px' }

}));


export function Footer() {
    const classes = useStyles();
    const history = useHistory();
    return (
        <Box className={classes.footer} component="footer" >
            <Container maxWidth="lg" className={classes.splitLine}>
                <Grid container spacing={3} justifyContent="space-between" className={classes.space}>
                    <Hidden smDown>
                        <Grid key="logo" md={3}>
                            <DeloitteLogoButton />
                        </Grid>
                    </Hidden>
                    {footers.map((footer, index) => (
                        <Grid key={footer.title} md={index === 0 ? 3 : 6}>
                            <Typography variant="h6" color="textPrimary" gutterBottom>
                                {footer.title}
                            </Typography>
                            <List>
                                {(footer.links as any[]).map((item, index) => (
                                    <ListItem key={index} disableGutters>
                                        <Link variant="subtitle1" color="textSecondary" onClick={() => (item.tile.href as string).startsWith("/") ? history.push(item.tile.href) : window.open(item.tile.href, '_blank')} style={{ cursor: "pointer" }}>
                                            {item.title}
                                        </Link>
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                    ))}
                </Grid>
                <Box>
                    <Copyright />
                </Box>
            </Container>
        </Box >
    );
}